import { PopupMenu } from 'shared/components/ui/popup-menu';
import styled from 'styled-components';

export const Menu = styled(PopupMenu)`
  max-width: 30.4rem;
`;

export const NoResultsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 1.6rem;
`;
